/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:17/01/2021
 @Time:15:52
 **/


import Produit from "../backend/produit/modele/Produit";
import Stock from "../backend/stock/model/Stock";
import ProduitPaquet from "../backend/produit/modele/ProduitPaquet";
import BonSortie from "../backend/bon_sortie/model/BonSortie";
import JsLogger from "../vendors/begro/js-logger";
import Vente from "../backend/vente_achat/model/vente";
import BonLivraison from "../backend/bon_livraison/model/BonLivraison";
export default class Begro{

    /**
     *@var {string}
     */
    static #baseURL;


    /**
     * env is dev or prod
     * @type {string}
     */
    static #_env="dev"

    /**
     * liste des produits  crées et mémorisés dans la page courante pour minimiser les appels ajax
     * @type {{}}
     * @private
     */
    static #_produitList={}

    /**
     *
     * @type {{}}
     */
    static #produitPaquetList={}

    /**
     * liste des ventes récupérés depuis serveur pour éviter le requête et traitement inutile
     * @type {Object<String,Vente>}
     */
    static #venteList={};


    /**
     * liste des devis récupérés depuis serveur pour éviter le requête et traitement inutile
     * @type {Object<String,Devis>}
     */
    static #devisList={};



    /**
     * liste des bons de livraison  récupérés depuis serveur pour éviter le requête et traitement inutile
     * @type {Object<String,BonLivraison>}
     */
    static #bonLivraisonList={};

    /**
     * dernier id temporaire affecté a une vente (pour les ventes encours de creation)
     * @type {number}
     */
    static #lastVenteTemporaireID=0;

    /**
     * liste des stock crées et mémorisés dans la page courante pour minimiser les appels ajax
     * @type {{}}
     * @private
     */
    static #stockList={}


    static #bonSortieList={}

    /**
     *@var {string}
     */
    static #hostName;

    /**
     * @var {string}
     */
    static #schema;

    /**
     * @type{string}
     */
    static #_port;

    static set baseURL(baseURL){
        this.#baseURL=baseURL;
        return this;
    }

    static get baseURL(){
        //todo déplacer le code vers le constructeur et rendre cette classe un service js singleton
        if(this.#baseURL==null)
        {
            if(typeof baseURL!=="undefined"){
                Begro.logInfo("base url est détecté avec succées depuis la page html : "+baseURL);
                this.#baseURL=baseURL;
            }else{
                Begro.logError("variable globale baseURL n'est pas définit dans votre page html");
            }
        }
        return this.#baseURL;
    }


    /**
     * @description Affiche un message log niveau information
     * @param {String} message
     * @param {{}=}object l'objet a afficher
     */
    static logInfo(message,object){
        JsLogger.info(message);
        JsLogger.info(this.#getObjectAsString(object));
    }


    /**
     * @description Affiche un message log niveau alerte
     * @param {String} message
     * @param {{}=}object l'objet a afficher
     */
    static logWarning(message,object){
        JsLogger.warning(message);
        JsLogger.warning(this.#getObjectAsString(object));
    }


    /**
     * @description permet d'afficher le continu d'un objet dans le log
     * @param {Object=} object
     * @return {string}
     */
    static #getObjectAsString(object){
        if(typeof object =="object")
        {
            return JSON.stringify(object,null,4);
        }
    }

    /**
     * @description  Affiche un message log niveau erreur
     * @param {String} message
     * @param {{}=}object l'objet a afficher
     */
    static logError(message,object){
        JsLogger.error(message);
        JsLogger.error(this.#getObjectAsString(object));
    }

    /**
     * @description Affiche un message log niveau débogage
     * @param {String} message
     * @param {{}=}object l'objet a afficher
     */
    static logDebug(message){
        JsLogger.debug(message);
        JsLogger.debug(this.#getObjectAsString(object));
    }

    /**
     * @description Affiche un message log niveau trace
     * @param {String} message
     * @param {{}=}object l'objet a afficher
     */
    static logTrace(message){
        JsLogger.trace(message);
        JsLogger.trace(this.#getObjectAsString(object));
    }

    /**
     *
     * @return {string}
     */
    static get port() {
        if(!Begro.#_port){
            this.#_port=(window.location.port!=="")?(':'+window.location.port):'';
        }
        return this.#_port;
    }


    static get hostName(){
        if(!Begro.#hostName){
            Begro.#hostName=window.location.hostname;
        }
        return Begro.#hostName;
    }


    static get schema(){
        if(!Begro.#schema){
            Begro.#schema=window.location.protocol;
        }
        return Begro.#schema;
    }

    /**
     * Ajoute un produit paquet a liste des produit paquet
     * @param {ProduitPaquet}produitPaquet
     */
    static addProduitPaquetList(produitPaquet){
        Begro.#produitPaquetList[produitPaquet.id]=produitPaquet;
    }


    /**
     * return begro env can be dev|prod
     * @return {string}
     */
    static get env() {
        return this.#_env;
    }

    static set env(value) {
        this.#_env = value;
    }

    /**
     * supprime un produit paquet a liste des produit paquet
     * @param {ProduitPaquet|string }produitPaquet - produit paquet ou son id
     */
    static removeProduitPaquetList(produitPaquet){
        let id= produitPaquet instanceof ProduitPaquet ? produitPaquet.id :produitPaquet;
        Begro.#produitPaquetList[id]!==undefined?delete Begro.#produitPaquetList[id]:false;
    }

    /**
     * Méthode qui retourne le produit paquet si trouvé sinon null
     * @param {string}id
     * @return {ProduitPaquet|null}
     */
    static getProduitPaquetById(id){
        return Begro.#produitPaquetList[id]!==undefined? Begro.#produitPaquetList[id]:null;
    }


    /**
     * ajoute un produit au liste des produits crée pour la page courante
     * @param {Produit}produit
     * @returns {Begro}
     */
    static addProduit(produit){
        Begro.#_produitList[produit.id]=produit;
        return this;
    }


    /**
     *
     * @param {string} id - id d'un produit qu'on veut récupérer
     * @return {Produit|null}
     */
    static getProduitByID(id){
        return (Begro.#_produitList.hasOwnProperty(id))? Begro.#_produitList[id]:null;
    }

    /**
     * ajoute un stock au liste des produits crée pour la page courante
     * @param {Stock}stock
     */
    static addStock(stock){
        Begro.#stockList[stock.produit.id]=stock;
    }

    /**
     *
     * @param {string|Produit} produit - id d'un produit qu'on veut récupérer ou une instance de la class Produit
     * @return {Stock|null}
     */
    static getStockByProduit(produit){
        let id=(produit instanceof Produit)?produit.id:produit;
        return (Begro.#stockList.hasOwnProperty(id))? Begro.#stockList[id]:null;
    }

    /**
     *
     * @param {string} id - id d'un BonSortieUI qu'on veut récupérer
     * @return {BonSortie|null}
     */
    static getBonSortieByID(id){
        return (Begro.#bonSortieList.hasOwnProperty(id))? Begro.#bonSortieList[id]:null;
    }

    /**
     * ajoute un stock au liste des produits crée pour la page courante
     * @param {BonSortie}bonSortie
     */
    static addBonSortie(bonSortie){
        Begro.#bonSortieList[bonSortie.id]=bonSortie;
    }

    /**
     * ajouter une vente
     * @param {Vente}vente
     */
    static addVente(vente)
    {
        Begro.#venteList[vente.id]=vente;
    }

    /**
     * récupérer une vente depuis le conteneur begro si elle existe
     * @param {string}  venteID
     * @return {Vente|null}
     */
    static getVente(venteID)
    {
        return (typeof Begro.#venteList[venteID] ==="object") ? Begro.#venteList[venteID]:null;
    }


    /**
     * ajouter un bon livraison
     * @param {BonLivraison} bonLivraison
     */
    static addBonLivraison(bonLivraison)
    {
        Begro.#bonLivraisonList[bonLivraison.id]=bonLivraison;
    }

    /**
     * récupérer un bon livraison depuis le conteneur begro si elle existe
     * @param {string}  bonLivraisonID
     * @return {BonLivraison|null}
     */
    static getBonLivraison(bonLivraisonID)
    {
        return (typeof Begro.#bonLivraisonList[bonLivraisonID] ==="object") ? Begro.#bonLivraisonList[bonLivraisonID]:null;
    }


    /**
     * ajouter un devis
     * @param {Devis} devis
     */
    static addDevis(devis)
    {
        Begro.#devisList[devis.id]=devis;
    }

    /**
     * récupérer un devis depuis le conteneur begro si elle existe
     * @param {string}  devisID
     * @return {Devis|null}
     */
    static getDevis(devisID)
    {
        return (typeof Begro.#devisList[devisID] ==="object") ? Begro.#devisList[devisID]:null;
    }


    /**
     * Methode que l'url complète (absolue)
     * @param {string}relativePath
     * @returns {string}
     */
    static getURL(relativePath){
      return  Begro.schema+"//"+Begro.hostName+(this.port)+Begro.baseURL+relativePath;
    }

    /**
     * @description indique si begro s'éxécute en mode développement ou production
     * @return {boolean}
     */
    static isDevMode(){
        return this.#_env==="development"||this.#_env==="dev";
    }




}
Begro.env=process.env.NODE_ENV.indexOf('production')>-1?"prod":"dev";